import { Button, Card, Divider, Modal, Row, Col } from "antd";
import _ from "lodash";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { Fragment, useState } from "react";
import styled from "styled-components";
import request from "superagent";
import { getAuthHeader } from "../../utils/superagent";

import { AddressCard, AddressEditModal, AddressViewMap } from "../../components/geoAddress";
import { formatAddressWithLine1 } from "../../utils/address";
import { getTimezone } from "@src/appV2/Timezone/api/useGetTimezone";
import { showErrorToast } from "@src/appV2/lib/Notifications";

const LocationCard = styled(Card)`
  .ant-card-body {
    padding: 12px;
    p {
      margin: 0;
    }
  }
`;

const MapContainer = styled(Col)`
  height: 400px;
  max-height: 80vh;
`;

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'address' implicitly has an 'any' type.
function AddressViewModal({ address, location, onEdit, ...props }) {
  const getLocation = () => {
    const [lng, lat] = _.get(location, "coordinates", []);
    return { lat, lng };
  };

  return (
    <Modal title="Address View" footer={null} width="80%" destroyOnClose={true} {...props}>
      <Row gutter={16}>
        <Col span={12}>
          <AddressCard address={address} onEdit={onEdit} />
        </Col>
        <MapContainer span={12}>
          <AddressViewMap location={getLocation()} />
        </MapContainer>
      </Row>
    </Modal>
  );
}

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'userId' implicitly has an 'any' type.
function LocationContainer({ userId, location, address, admin, retrieveUser, saveUser, type }) {
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);

  const onCancel = () => setIsEdit(false);
  const onEdit = () => setIsEdit(true);
  const onView = () => setIsView(true);
  const onViewClose = () => setIsView(false);
  // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
  const updateProfileEndpoint = `${global.api}/agentprofile/address`;
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'place' implicitly has an 'any' type.
  const onAddressChange = async (place) => {
    try {
      const timezoneResponse = await getTimezone({
        latitude: place.location.lat,
        longitude: place.location.lng,
      });
      await saveUser({ id: userId, tmz: timezoneResponse.data.data.attributes.name });
      const endpointByType =
        // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
        type === "AGENT" ? updateProfileEndpoint : `${global.api}/facilityprofile/address`;
      return request
        .post(endpointByType)
        .set(await getAuthHeader())
        .send({
          session: userId,
          ...place,
          performedBy: admin,
          tmz: timezoneResponse.data.data.attributes.name,
        })
        .then(handleResponse)
        .catch((err) => showErrorToast(err.response?.text || "An error occurred"));
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      showErrorToast(error.response?.text || "An error occurred while saving user");
    }
  };

  const handleResponse = () => {
    setTimeout(() => {
      retrieveUser(userId);
      return setIsEdit(false);
    }, 2000);
  };

  function Actions() {
    return (
      <Fragment>
        <Button data-testid="hcpDrawer-address-edit" type="link" onClick={onEdit}>
          Edit
        </Button>
        <Divider type="vertical" />
        <Button type="link" onClick={onView} disabled={_.isEmpty(location)}>
          View
        </Button>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <LocationCard title="Address" extra={<Actions />}>
        <p>{address ? formatAddressWithLine1(address) : "Not added"}</p>
      </LocationCard>
      <AddressEditModal visible={isEdit} onCancel={onCancel} onComplete={onAddressChange} />
      <AddressViewModal
        location={location}
        address={address}
        onEdit={onEdit}
        visible={isView}
        onCancel={onViewClose}
        destroyOnClose={true}
      />
    </Fragment>
  );
}

export { LocationContainer };
